module.exports = __webpack_public_path__ + "static/room3-3-136d12ff39e37800ee4def0b21bd1362.jpg";